"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.template3 = void 0;
const common_1 = require("./common");
const useBreakpoints_1 = require("../utils/useBreakpoints");
exports.template3 = {
    container: (theme) => {
        const largeScreenStyles = `
      form > div {
        align-items: stretch;
        grid-template-columns: min-content auto repeat(3, min-content);
      }
    `;
        return `
      font-family: ${theme.sw_font_face};
      background-color: transparent;
      padding: ${theme.sw_container_padding_v} ${theme.sw_container_padding_h};

      form > div {
        display: grid;
        width: 100%;
        grid-template-columns: min-content auto;
        grid-template-rows: auto;
      }

      &.__cq__[data-breakpoint=md] {
        ${largeScreenStyles}
      }

      &.__mq__{
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }
  `;
    },
    searchLabel: (theme) => {
        const { label } = (0, common_1.sharedTemplateFreeText)(theme);
        const largeScreenStyles = `
      border-bottom: 1px solid ${theme.sw_color_border};
      border-radius: ${theme.sw_border_radius_container} 0 0 ${theme.sw_border_radius_container};
      grid-column: 1;
      grid-row: 1;

      +div {
        border-left: none;
        border-radius: 0;
        padding-left: ${theme.sw_spacing_small};
        grid-column: 2;
        grid-row: 1;
      }
    `;
        return `
      ${label}

      background-color: ${theme.sw_color_bg_container};
      white-space: nowrap;
      margin-bottom: 0;
      border-top: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      border-radius: ${theme.sw_border_radius_container} 0 0 0;
      padding: ${theme.sw_spacing_xlarge} ${theme.sw_spacing_small} ${theme.sw_spacing_medium} ${theme.sw_spacing_medium};
      grid-column: 1;
      grid-row: 1;

      +div {
        border-left: none;
        border-radius: 0 ${theme.sw_border_radius_container} 0 0;
        padding-left: ${theme.sw_spacing_small};
        grid-column: 2;
        grid-row: 1;
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    // searchInput is actually the <div> wrapping the MUI autocomplete component
    searchInput: (theme) => {
        const { input } = (0, common_1.sharedTemplateFreeText)(theme);
        const largeScreenStyles = `
      border-right: none;
      border-bottom: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      border-radius: ${theme.sw_border_radius_container} 0 0 ${theme.sw_border_radius_container};
      padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_small} ${theme.sw_spacing_medium} ${theme.sw_spacing_medium};
      grid-column: 1 / span 2;
      grid-row: 1;
    `;
        return `
      ${input}

      background-color: ${theme.sw_color_bg_container};
      border-top: 1px solid ${theme.sw_color_border};
      border-right: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      border-radius: ${theme.sw_border_radius_container} ${theme.sw_border_radius_container} 0 0;
      padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_medium} ${theme.sw_spacing_small} ${theme.sw_spacing_medium};
      grid-column: 1 / span 2;
      grid-row: 1;

      input {
        border: none;
        padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_small};
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    localeLabel: (theme) => {
        const { label } = (0, common_1.sharedTemplateLocale)(theme);
        const largeScreenStyles = `
      border-top: 1px solid ${theme.sw_color_border};
      border-bottom: 1px solid ${theme.sw_color_border};
      border-left: none;
      padding: ${theme.sw_spacing_xlarge} ${theme.sw_spacing_small} ${theme.sw_spacing_medium} ${theme.sw_spacing_small};
      grid-column: 3;
      grid-row: 1;

      +div {
        grid-column: 4;
        grid-row: 1;
      }
    `;
        return `
      ${label}

      background-color: ${theme.sw_color_bg_container};
      white-space: nowrap;
      margin-bottom: 0;
      border-left: 1px solid ${theme.sw_color_border};
      padding: ${theme.sw_spacing_xlarge} ${theme.sw_spacing_small} ${theme.sw_spacing_medium} ${theme.sw_spacing_medium};
      grid-column: 1;
      grid-row: 3;

      +div {
        border-left: none;
        padding-left: ${theme.sw_spacing_small};
        grid-column: 2;
        grid-row: 3;
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    // localeInput is actually the <div> wrapping the input
    localeInput: (theme) => {
        const { input } = (0, common_1.sharedTemplateLocale)(theme);
        const largeScreenStyles = `
      min-width: 200px;
      border-top: 1px solid ${theme.sw_color_border};
      border-right: none;
      border-bottom: 1px solid ${theme.sw_color_border};
      border-left: none;
      padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_small};
      grid-column: 3 / span 2;
      grid-row: 1;
    `;
        return `
      ${input}

      background-color: ${theme.sw_color_bg_container};
      border-right: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_medium} ${theme.sw_spacing_small} ${theme.sw_spacing_medium};
      grid-column: 1 / span 2;
      grid-row: 3;

      input {
        border: none;
        padding: ${theme.sw_spacing_medium} ${theme.sw_spacing_small};
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    button: (theme) => {
        const shared = (0, common_1.sharedTemplateButton)(theme);
        const largeScreenStyles = `
      border-top: 1px solid ${theme.sw_color_border};
      border-left: none;
      border-radius: 0 ${theme.sw_border_radius_container} ${theme.sw_border_radius_container} 0;
      padding: 0 0 0 ${theme.sw_spacing_small};
      grid-column: 5;
      grid-row: 1;
      
      button {
        border-radius: 0 ${theme.sw_border_radius_container} ${theme.sw_border_radius_container} 0;
        padding: ${theme.sw_spacing_small} ${theme.sw_spacing_xlarge};
      }
    `;
        return `
      ${shared}

      background-color: ${theme.sw_color_bg_container};
      border-right: 1px solid ${theme.sw_color_border};
      border-bottom: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      border-radius: 0 0 ${theme.sw_border_radius_container} ${theme.sw_border_radius_container};
      padding-top: ${theme.sw_spacing_small};
      grid-column: 1 / span 2;
      grid-row: 4;
      
      button {
        border-radius: 0 0 ${theme.sw_border_radius_container} ${theme.sw_border_radius_container};
        padding: ${theme.sw_spacing_large} ${theme.sw_spacing_small};
        height: 100%;
        width: 100%;

        &:focus, &:active {
          outline-offset: 1px;
        }
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }

    `;
    },
    autoComplete: (theme) => {
        const { listItem, popper, chip, chipContainer, groupHeading } = (0, common_1.sharedTemplateAutoComplete)(theme);
        return {
            listItem: `
      ${listItem}
    `,
            popper: `
      ${popper}
    `,
            chip: `
      ${chip}
    `,
            chipContainer: `
      ${chipContainer}
    `,
            groupHeading: `
      ${groupHeading}
    `
        };
    },
    extLink: (theme) => {
        const shared = (0, common_1.sharedTemplateExtLink)(theme);
        const largeScreenStyles = `
      grid-column: 1 / span 5;
      grid-row: 3;
    `;
        return `
      ${shared}

      margin: ${theme.sw_spacing_medium};
      grid-column: 1 / span 2;
      grid-row: 5;

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    emptySearchError: (theme) => {
        const shared = (0, common_1.sharedTemplateEmptySearchError)(theme);
        const largeScreenStyles = `
      background-color: transparent;
      padding: ${theme.sw_spacing_xsmall} ${theme.sw_spacing_small};
      border: none;
      grid-column: 2;
      grid-row: 2;
    `;
        return `
      ${shared}

      background-color: ${theme.sw_color_bg_container};
      margin: 0;
      padding: ${theme.sw_spacing_xsmall} ${theme.sw_spacing_medium};
      border-right: 1px solid ${theme.sw_color_border};
      border-left: 1px solid ${theme.sw_color_border};
      grid-column: 1 / span 2;
      grid-row: 2;

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    }
};
//# sourceMappingURL=template3.js.map